import React, { useState, useEffect } from 'react';

import { Modal, Button, Form } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';

import { useDisableAIModule } from '../api';
import {
  AIModulePayload,
  emptyAI,
  AIModuleEntity,
  aiEntityToPayload,
} from '../types';

type RBModalProps = {
  show: boolean;
  handleClose: () => void;
  aiModuleSelected: AIModuleEntity;
};

/**
 * == Delete AI Module Modal ==
 * @returns
 */
export const DeleteAIModule = ({
  show,
  handleClose,
  aiModuleSelected,
}: RBModalProps) => {
  // == form upload payload ==
  const [payload, setPayload] = useState<AIModulePayload>(emptyAI);

  const disableQuery = useDisableAIModule({
    onSuccess: () => handleClose(),
  });

  const { isLoading } = disableQuery;

  const handleSubmitToDeleteAIModule = async (
    event: React.FormEvent<HTMLFormElement>
  ) => {
    event.preventDefault();
    await disableQuery.mutateAsync({ id: payload.id as number });
  };

  /**
   * observe selected AI module to reset current form
   */
  useEffect(() => {
    setPayload(aiEntityToPayload(aiModuleSelected));
  }, [aiModuleSelected]);

  return (
    <Modal as={Modal.Dialog} centered show={show} onHide={handleClose}>
      <Modal.Header>
        <Modal.Title className="h6">Disable AI Module</Modal.Title>
        <Button variant="close" aria-label="Close" onClick={handleClose} />
      </Modal.Header>
      <Form onSubmit={handleSubmitToDeleteAIModule}>
        <Modal.Body>
          {/* == companies selection == */}
          <Form.Group className="mb-2">
            <Form.Label>Sure to disable AI module?</Form.Label>
            <Form.Control readOnly name="label" defaultValue={payload.label} />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button type="submit" variant="warning">
            {isLoading && (
              <>
                <Spinner size="sm" animation="border" />
                ......
              </>
            )}
            {!isLoading && `Save`}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};
